import PropTypes from 'prop-types';
import React from 'react';
import { LiveMessage } from 'react-aria-live';
import reactT from './../../components/reactT';

function searchResultsStat(pending,currentPage, numFound, rows, pageAmt, noResultsText, termValue, className, uniqueId) {
  // Set visible and a11y message based on query results.
  let message = '';
  let options = [];
  options['@count'] = numFound;
  if (numFound > rows && !pending) { // Many pages
    message = 'Showing @count results for';
  } else if (numFound <= rows && numFound > 1) { // Single page
    message = 'Showing @count results for';
  } else if (numFound === 1) { // Single item
    message = reactT('Showing @count result for');
  } else if (numFound === 0 && !pending) { // No results
    message = noResultsText || 'Sorry, your search yielded no results.';
  } else if (pending){
    message = reactT('Waiting for results');
  }

  // Don't announce total results when wildcard query sent on term clear.
  return (
      <React.Fragment>
        <LiveMessage message={reactT(message, options)} aria-live="polite" />
        <p id={uniqueId} tabIndex="-1" className={"view-header" + (className !== undefined ? ' ' + className : '')}>{reactT(message, options)}</p>
      </React.Fragment>
  );
}

class FederatedCountLabel extends React.Component {
  constructor(props) {
    super(props);
    this.uniqueId = `stat-${Math.random().toString(36).substring(7)}`;
  }

  render() {
    const {
      pending,
      numFound,
      start,
      rows,
      noResultsText,
      termValue,
      className
    } = this.props;
    const currentPage = start / rows;
    const pageAmt = Math.ceil(numFound / rows);
    return (
        <React.Fragment>
          {searchResultsStat(pending,currentPage, numFound, rows, pageAmt, noResultsText, termValue, className, this.uniqueId)}
        </React.Fragment>
    );
  }
}

FederatedCountLabel.propTypes = {
  numFound: PropTypes.number.isRequired,
  start: PropTypes.number.isRequired,
  rows: PropTypes.number,
};

FederatedCountLabel.defaultProps = {
  start: 0,
};

export default FederatedCountLabel;
